import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { AddToCartContext } from './AddToCartContext';

const CartDropdownFooter = ({ onClick }) => {
    const { colors, buttonFields } = useContext(AddToCartContext);
    
    return (
        <Button
            hoverStyleChange={false}
            onClick={onClick}
            primaryColor='#FAD539'
            secondaryColor='#FAD539'
            className="product-button flex-center obsessvr-regularFont full-width pointer checkoutBtn"
            style={{ padding: '0', margin: '1em auto', borderRadius: '0px', width: '60%', height: '2em' }}
            // primaryBorderWidth={buttonFields.buyNowBorderActiveOn && buttonFields.buyNowBorderActiveOn.primary ? buttonFields.buttonBorderWidth : undefined}
            // secondaryBorderWidth={buttonFields.buyNowBorderActiveOn && buttonFields.buyNowBorderActiveOn.secondary ? buttonFields.buttonBorderWidth : undefined}
            primaryBorderColor={colors && colors.buyNowBorderColor}
            secondaryBorderColor={colors && colors.buyNowBorderColor}
            insetBorder={true}
            padded={false}
        >
            <span className='obsessvr-regularFont ' style={{color:'black',fontWeight: '700',fontSize: '14px'}}>
                CHECK OUT
            </span>
        </Button>
    )
}

export default CartDropdownFooter;
